import React from 'react';
import {Box, Typography} from '@mui/material';

type InfoRowProps = {
  label: string;
  value: string;
};

const AurTileInfo: React.FC<InfoRowProps> = ({label, value}) => {
  return (
    <Box className="client-accordion-info">
      <Box>
        <Typography variant="body2" className="info-label">
          {label}:
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" className="info-value">
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default AurTileInfo;
